import type { ReactNode } from 'react';
import styled from 'styled-components';
import { colors } from '../../../../styles/colors';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  background: ${colors.background};
`;

export type OnboardingFlowShellProps = {
  children: ReactNode;
};

/** Minimal full-viewport shell for onboarding gate loading/error states (no header, footer, or form). */
export function OnboardingFlowShell({ children }: OnboardingFlowShellProps) {
  return <Root>{children}</Root>;
}
